export enum TransactionType {
    BOOKING,
    PAYMENT,
}
